// Environment configuration
const env = {
  // API Configuration
  API_URL: import.meta.env.VITE_API_URL || "http://localhost:8080/api",
  PUBLIC_API_URL: import.meta.env.VITE_PUBLIC_API_URL || "http://127.0.0.1:8000",

  // App Configuration
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || "development",

  // Feature Flags
  ENABLE_DEBUG: import.meta.env.VITE_ENABLE_DEBUG === "true",

  // Heimdall auth service
  HEIMDALL_URL: import.meta.env.VITE_HEIMDALL_URL as string,

  // Puzzle app URL (used to build OAuth callback URL)
  PUZZLE_URL: import.meta.env.VITE_PUZZLE_URL as string,
};

export default env;

